import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.reflect.construct";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { __decorate } from "tslib";
import { Vue, Component, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import * as navigation from '~/store/navigation';
var Navigation = namespace(navigation.name);

var NavBarItem = /*#__PURE__*/function (_Vue) {
  _inherits(NavBarItem, _Vue);

  var _super = _createSuper(NavBarItem);

  function NavBarItem() {
    var _this;

    _classCallCheck(this, NavBarItem);

    _this = _super.apply(this, arguments);
    _this.isSubmenuOpen = false;
    return _this;
  }

  _createClass(NavBarItem, [{
    key: "toggleSubmenu",
    value: function toggleSubmenu() {
      this.isSubmenuOpen = !this.isSubmenuOpen;
    }
  }]);

  return NavBarItem;
}(Vue);

__decorate([Prop(Object)], NavBarItem.prototype, "item", void 0);

NavBarItem = __decorate([Component({})], NavBarItem);
export default NavBarItem;